import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { Contact } from 'types/contact.type';
import { queryKeys } from 'services/hooks/queryKeys';
import { UpdateContactStatus } from 'components/AgentCallConsole/components';

import styles from '../ContactDrawer.module.scss';

interface TabChangeStatusProps {
    rawStatusOptions: string[];
    contact: Contact;
}
export const TabChangeStatus = ({ rawStatusOptions, contact }: TabChangeStatusProps) => {
    const [updatedContactStatus, setUpdatedContactStatus] = useState<string>('');

    const queryClient = useQueryClient();

    const getCurrentStatusDisplay = (status: string): string => {
        return status.replace(/_/g, ' ') || 'Not Available';
    };

    const currentStatus = updatedContactStatus || contact?.status;

    return (
        <div className={styles.changeStatus}>
            <UpdateContactStatus
                statuses={rawStatusOptions}
                contactId={contact.contactId}
                initialStatus={currentStatus}
                statusLabel={`Current Status: ${getCurrentStatusDisplay(currentStatus)}`}
                onStatusUpdateSuccess={(contactStatus) => {
                    setUpdatedContactStatus(contactStatus);

                    queryClient.invalidateQueries({ queryKey: queryKeys.contacts({}) });
                    queryClient.invalidateQueries({ queryKey: queryKeys.contactDetails(contact.contactId) });
                }}
            />
        </div>
    );
};
